import { render, staticRenderFns } from "./ContactsItemBlock.vue?vue&type=template&id=9eb4dfb8&"
import script from "./ContactsItemBlock.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ContactsItemBlock.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9eb4dfb8')) {
      api.createRecord('9eb4dfb8', component.options)
    } else {
      api.reload('9eb4dfb8', component.options)
    }
    module.hot.accept("./ContactsItemBlock.vue?vue&type=template&id=9eb4dfb8&", function () {
      api.rerender('9eb4dfb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/contacts/components/ContactsItemBlock.vue"
export default component.exports